import HeroContent from 'components/HeroConsolidated/shared/HeroContent';
import HeroCTA from 'components/HeroConsolidated/shared/HeroCTA';
import Eyebrow from 'components/shared/Eyebrow/Eyebrow';
import HeroWrapper, { HeroContentWrapper } from 'components/HeroConsolidated/shared/HeroWrapper';
import { FullBleedVideoPlayer } from 'components/VideoPlayer';
import { HeroConsolidatedProps } from 'libs/contentful/props';
import { CSSProperties } from 'react';
import { cn, getColorway } from 'utils/styles';

const HeroFullBleedVariant = ({
  desktopMedia,
  mobileMedia,
  color,
  headline,
  copy,
  sys,
  showEmailInput,
  emailInputButtonText,
  cta,
  disclaimerModal,
  scrollCta,
  disclaimers,
  margins,
  sectionName,
  eyebrowAlternateLogo,
  eyebrowChimeLogo,
  eyebrowText,
  allowPromoCodeEntry,
  promoCodeInputButtonText,
  promoCodes,
  video,
  className,
  innerClassName,
  enrollmentUrl,
}: HeroConsolidatedProps) => {
  const hasVideo = video != null && video.video != null; // Linked videos are not supported by this module variant
  const desktopUrl = hasVideo ? video.previewImage.url : desktopMedia?.url;
  const mobileUrl = hasVideo ? video.previewImage.url : (mobileMedia?.url ?? desktopMedia?.url);

  return (
    <div
      style={
        {
          '--image-url': `url(${desktopUrl})`,
          '--mobile-image-url': `url(${mobileUrl})`,
        } as CSSProperties
      }
      className={cn(
        getColorway(color),
        'bg-transparent', // Transparent background so the play button gets right color
        'hero-container md:min-h-125 max-sm:min-h-150 w-full h-full',
        'bg-[image:var(--mobile-image-url)] sm:bg-[image:var(--image-url)] bg-center bg-cover relative',
        className,
      )}>
      {hasVideo && <FullBleedVideoPlayer video={video} />}
      <HeroWrapper
        testId={'fullBleedVariant'}
        className={cn('bg-inherit drop-shadow-[0px_4px_4px_rgba(5,35,22,0.75)] max-sm:min-h-150 flex', innerClassName)}
        color={color}
        margins={margins}
        sectionName={sectionName}>
        <HeroContentWrapper className="sm:max-w-1/2 h-full flex flex-col">
          <div className="flex flex-col-reverse">
            <HeroContent headline={headline} copy={copy} sys={sys} />
            <Eyebrow
              eyebrowAlternateLogo={eyebrowAlternateLogo}
              eyebrowChimeLogo={eyebrowChimeLogo}
              eyebrowText={eyebrowText}
              color={color}
              isHeading={true}
              sys={sys}
            />
          </div>
          <HeroCTA
            showEmailInput={showEmailInput}
            sys={sys}
            emailInputButtonText={emailInputButtonText}
            cta={cta}
            disclaimerModal={disclaimerModal}
            disclaimers={disclaimers}
            scrollCta={scrollCta}
            allowPromoCodeEntry={allowPromoCodeEntry}
            promoCodeInputButtonText={promoCodeInputButtonText}
            promoCodes={promoCodes}
            enrollmentUrl={enrollmentUrl}
            className={'flex-end'}
          />
        </HeroContentWrapper>
      </HeroWrapper>
    </div>
  );
};

export default HeroFullBleedVariant;
